import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiX } from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';

const CookieBanner = () => {
  const { lang } = useLanguage();
  const en = lang === 'en';
  const [visible, setVisible] = useState(false);
  const [showPrefs, setShowPrefs] = useState(false);
  const [prefs, setPrefs] = useState({
    necessary: true, // always true, cannot be disabled
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const check = () => {
      const saved = localStorage.getItem('cp_cookie_consent');
      if (!saved) {
        setVisible(true);
      }
    };
    check();
    window.addEventListener('cp_cookie_reset', () => {
      setVisible(true);
      setShowPrefs(true);
    });
  }, []);

  const save = (consent) => {
    const data = {
      ...consent,
      timestamp: new Date().toISOString(),
      version: '1.0',
    };
    localStorage.setItem('cp_cookie_consent', JSON.stringify(data));
    setVisible(false);
    setShowPrefs(false);
  };

  const acceptAll = () => save({ necessary: true, analytics: true, marketing: true });
  const rejectAll = () => save({ necessary: true, analytics: false, marketing: false });
  const saveCustom = () => save(prefs);

  if (!visible) return null;

  return (
    <>
      <div className="cookie-banner-backdrop" onClick={() => {}} />
      <div className="cookie-banner" role="dialog" aria-labelledby="cookie-banner-title" aria-modal="true">
        {!showPrefs ? (
          <>
            <div className="cookie-banner-content">
              <h2 id="cookie-banner-title" className="cookie-banner-title">
                {en ? 'We respect your privacy' : 'Rispettiamo la tua privacy'}
              </h2>
              <p className="cookie-banner-text">
                {en
                  ? 'We use cookies to ensure the basic functioning of the site and, with your consent, to analyse traffic and personalise content. You can accept, reject or customise your preferences. Your choice is revocable at any time. '
                  : "Utilizziamo i cookie per garantire il funzionamento base del sito e, con il tuo consenso, per analizzare il traffico e personalizzare i contenuti. Puoi accettare, rifiutare o personalizzare le tue preferenze. La scelta e' revocabile in qualsiasi momento. "}
                <Link to="/cookie" className="cookie-banner-link">{en ? 'Read the Cookie Policy' : 'Leggi la Cookie Policy'}</Link>
                {' | '}
                <Link to="/privacy" className="cookie-banner-link">{en ? 'Privacy Policy' : 'Privacy Policy'}</Link>
              </p>
              <div className="cookie-banner-buttons">
                <button className="cookie-btn cookie-btn-reject" onClick={rejectAll}>
                  {en ? 'Reject all' : 'Rifiuta tutti'}
                </button>
                <button className="cookie-btn cookie-btn-customize" onClick={() => setShowPrefs(true)}>
                  {en ? 'Customise' : 'Personalizza'}
                </button>
                <button className="cookie-btn cookie-btn-accept" onClick={acceptAll}>
                  {en ? 'Accept all' : 'Accetta tutti'}
                </button>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="cookie-banner-content">
              <div className="cookie-prefs-header">
                <h2 className="cookie-banner-title">
                  {en ? 'Cookie preferences' : 'Preferenze cookie'}
                </h2>
                <button className="cookie-close-btn" onClick={() => setShowPrefs(false)} aria-label="Close">
                  <FiX size={22} />
                </button>
              </div>
              <div className="cookie-pref-row">
                <div style={{ flex: 1 }}>
                  <div className="cookie-pref-label">{en ? 'Necessary (always active)' : 'Necessari (sempre attivi)'}</div>
                  <div className="cookie-pref-desc">
                    {en
                      ? 'Essential cookies for the basic functioning of the site. Cannot be disabled.'
                      : 'Cookie essenziali per il funzionamento base del sito. Non possono essere disattivati.'}
                  </div>
                </div>
                <label className="cookie-toggle">
                  <input type="checkbox" checked disabled />
                  <span className="cookie-toggle-slider" />
                </label>
              </div>
              <div className="cookie-pref-row">
                <div style={{ flex: 1 }}>
                  <div className="cookie-pref-label">{en ? 'Analytics' : 'Analitici'}</div>
                  <div className="cookie-pref-desc">
                    {en
                      ? 'Help us understand how visitors use the site anonymously.'
                      : 'Ci aiutano a capire come gli utenti utilizzano il sito in forma anonima.'}
                  </div>
                </div>
                <label className="cookie-toggle">
                  <input
                    type="checkbox"
                    checked={prefs.analytics}
                    onChange={(e) => setPrefs({ ...prefs, analytics: e.target.checked })}
                  />
                  <span className="cookie-toggle-slider" />
                </label>
              </div>
              <div className="cookie-pref-row">
                <div style={{ flex: 1 }}>
                  <div className="cookie-pref-label">{en ? 'Marketing' : 'Marketing'}</div>
                  <div className="cookie-pref-desc">
                    {en
                      ? 'Used to show relevant content and personalised advertisements.'
                      : 'Utilizzati per mostrare contenuti rilevanti e pubblicita\' personalizzata.'}
                  </div>
                </div>
                <label className="cookie-toggle">
                  <input
                    type="checkbox"
                    checked={prefs.marketing}
                    onChange={(e) => setPrefs({ ...prefs, marketing: e.target.checked })}
                  />
                  <span className="cookie-toggle-slider" />
                </label>
              </div>
              <div className="cookie-banner-buttons" style={{ marginTop: '20px' }}>
                <button className="cookie-btn cookie-btn-reject" onClick={rejectAll}>
                  {en ? 'Reject all' : 'Rifiuta tutti'}
                </button>
                <button className="cookie-btn cookie-btn-accept" onClick={saveCustom}>
                  {en ? 'Save preferences' : 'Salva preferenze'}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CookieBanner;
